import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import {ref} from 'vue';
import TbHeader from '@/components/h_tb_header/tb_header.vue';
import TbContent from '@/components/h_tb_content/tb_content.vue';
import {useTable} from "@/components/h_tb_content/tb_content_data";
import {FormInline} from "@/components/h_tb_header/tb_header_data";
import {useCheckPage} from "./h_check_page_data";
import {ElLoading} from "element-plus";

// 定义数据类型
interface Tb {
  "idCardNo": string,
  "phone": string,
  "price": string,
  "transAmt": string,
  "rePayTime": string | null,
  "payTime": string,
  "state": string,
  "type": string,
  "reqSeqId": string,
  "reqDate": string,
  "isD": boolean | null,
  'gong': string ,
  "multiPeriodNo": string,
}

// 表单数据（由父组件定义，传给子组件）

export default /*@__PURE__*/_defineComponent({
  __name: 'h_check_page',
  setup(__props) {

const formInline = ref<FormInline>({
  idCard: '',
  cardMp: '',
  cardNo: '',
  state: '',
  date: ["", ""],
  reqSeqId: '',
  hfSeqId: '',
  reqDate: '',
});


// 1. 定义共享数据状态
const sharedTableData = ref<Tb[]>([])

// 2. 使用页面逻辑（支持外部传入状态实现动态变化）
const {currentPage, pageSize, total, onSubmit, handlePageChange, handleExport} = useCheckPage(
    sharedTableData,
    formInline,
    {
      // 可选：传入外部响应式状态实现动态变化
      // currentPage: ref(1),
      // pageSize: ref(10),
      // total: ref(0)
    },
    () => {
      // onSubmit();
    }
)

// 3. 初始化表格逻辑，传入共享数据引用
const {handleEdit, handleDelete} = useTable(sharedTableData, () => {
  const loadingInstance = ElLoading.service({fullscreen: true})
  setTimeout(() => {
    loadingInstance.close();
    onSubmit()
  }, 3000); // 1000毫秒 = 1秒
});

// 初始加载
// onSubmit();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(TbHeader, {
      "form-data": formInline.value,
      onSearch: _unref(onSubmit),
      onExport: _unref(handleExport)
    }, null, 8, ["form-data", "onSearch", "onExport"]),
    _createVNode(TbContent, {
      tableData: sharedTableData.value,
      handleEdit: _unref(handleEdit),
      handleDelete: _unref(handleDelete),
      total: _unref(total),
      "current-page": _unref(currentPage),
      "page-size": _unref(pageSize),
      onPageChange: _unref(handlePageChange)
    }, null, 8, ["tableData", "handleEdit", "handleDelete", "total", "current-page", "page-size", "onPageChange"])
  ], 64))
}
}

})